import { render, staticRenderFns } from "./StartTestButton.vue?vue&type=template&id=2d097afb&scoped=true&"
import script from "./StartTestButton.vue?vue&type=script&lang=js&"
export * from "./StartTestButton.vue?vue&type=script&lang=js&"
import style0 from "./StartTestButton.vue?vue&type=style&index=0&id=2d097afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d097afb",
  null
  
)

export default component.exports